import { type WhereFilterOp } from "@doitintl/models-types";

import { type FieldPath } from "./path";

export type ArrayValueOperators = "in" | "not-in";

export type ArrayPropertyOperatorsAny = "array-contains-any";

export type ArrayPropertyOperatorsSingle = "array-contains";

export type OrderByDirection = "asc" | "desc";

export abstract class QueryCompositeFilterConstraint {
  constructor(readonly type: "or" | "and") {}
}

function fieldPathFromArgument(arg: string | FieldPath): string {
  if (typeof arg === "string") {
    return arg;
  }

  return arg._internalPath.toArray().join(".");
}

export type QueryConstraintType =
  | "where"
  | "orderBy"
  | "limit"
  | "limitToLast"
  | "startAt"
  | "startAfter"
  | "endAt"
  | "endBefore";

export abstract class QueryConstraint {
  abstract readonly type: QueryConstraintType;
}

export class QueryFieldFilterConstraint extends QueryConstraint {
  readonly type = "where";

  constructor(
    readonly field: string,
    readonly op: WhereFilterOp,
    readonly value: unknown
  ) {
    super();
  }
}

export type QueryFilterConstraint = QueryFieldFilterConstraint | QueryCompositeFilterConstraint;

export function where(field: string | FieldPath, op: WhereFilterOp, value: unknown): QueryFieldFilterConstraint {
  const fieldPath = fieldPathFromArgument(field);
  return new QueryFieldFilterConstraint(fieldPath, op, value);
}

export class OrQueryCompositeFilterConstraint extends QueryCompositeFilterConstraint {
  constructor(readonly filters: QueryFilterConstraint[]) {
    super("or");
  }
}

export class AndQueryCompositeFilterConstraint extends QueryCompositeFilterConstraint {
  constructor(readonly filters: QueryFilterConstraint[]) {
    super("and");
  }
}

export function or(...queryConstraints: QueryFilterConstraint[]): OrQueryCompositeFilterConstraint {
  return new OrQueryCompositeFilterConstraint(queryConstraints);
}

export function and(...queryConstraints: QueryFilterConstraint[]): AndQueryCompositeFilterConstraint {
  return new AndQueryCompositeFilterConstraint(queryConstraints);
}
